module.exports = __webpack_public_path__ + "img/img_my_bg.e7a38f78.png";